import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

export const Wrapper = styled.div`
  margin: 20px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 160px);
  max-width: 100%;

  ${media.sm`
        min-height: unset;
        height: 483px;
        width: 550px;
        margin: auto;
        margin-bottom: 1.5em;
    `}
`;
